// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"13c65b8b","126":"f05b8a14","171":"67f05187","388":"34fb0cdf","453":"84a30ff1"}[chunkId] + ".chunk.js";
};